import { Spinner } from "@motleyhand/design"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(user)/(tenantBc)/datasets/$id")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Spinner />
}
